module.exports = __webpack_public_path__ + "img/flaggstikk2.f5823e19.jpg";